import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
@Component({
  selector: 'app-delegation',
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './delegation.component.html',
  styleUrl: './delegation.component.css'
})
export class DelegationComponent implements OnInit{
  data:any;
  constructor(private router:Router){}
  
  ngOnInit(): void {
    this.data = history.state.data;
  }

  onClick(): void {
    this.router.navigate(['PermanentDelegation/home/delegation/singledelegation'],
      { state: { data: this.data } });
  }

  click():void{
    this.router.navigate(['PermanentDelegation/home/delegation/multipledelegation'],
      { state: { data: this.data } }
    );
  }
  }

